import { useEffect, useState } from "react";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import Text from "../../../../styleguide/Text";
import AutocompleteDropdown from "../../../../components/misc/Autocomplete";

const daysAutocompleteData = [
  {
    value: 99,
    label: "Toate zilele",
  },
  {
    value: 0,
    label: "Luni",
  },
  {
    value: 1,
    label: "Marti",
  },
  {
    value: 2,
    label: "Miercuri",
  },
  {
    value: 3,
    label: "Joi",
  },
  {
    value: 4,
    label: "Vineri",
  },
  {
    value: 5,
    label: "Sambata",
  },
  {
    value: 6,
    label: "Duminica",
  },
];

function OrdersByDeliveryDayDataHeader() {
  const { handleTableSearch } = useTableCtx() || {};

  const [selectedItems, setSelectedItems] = useState<any[]>([]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("days", JSON.stringify(selectedItems));
  }, [handleTableSearch, selectedItems]);

  return (
    <div className="d-flex align-items-center justify-content-between mb-5">
      <Text
        variant="h3"
        component="h3"
        className="card-title mb-4"
        gutterBottom>
        Comenzi pe zi
      </Text>
      <AutocompleteDropdown
        id="autocomplete"
        labelTag="label"
        style={{ minWidth: "250px" }}
        placeholder="Seleteaza zilele"
        data={daysAutocompleteData}
        value={selectedItems}
        setSelectedItems={setSelectedItems}
      />
    </div>
  );
}

export default OrdersByDeliveryDayDataHeader;
